
import { ApplicationConfigurationKeys, LOCALSTORAGE_KEY, MODULE, PRODUCTS } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
const menuModel = (lang, userMenus, user) => {
    // FOR DEFAULT MENU
    var subMenus = userMenus;
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const disableLiveEventSection = company && company?.disableLiveEventSection !== undefined && company?.disableLiveEventSection
    subMenus = GetUserFavMenu();
    subMenus.push({
        type: 0,
        // onclick: openUserFavMenuDialog(),
        link: 'UserFavourite',
        modulesid: MODULE.USER_FAVOURITE,
        name: lang.user_favourite_add_button_title
    });
    const digitalSignProduct = company && company?.Products?.length === 1 && company?.Products.some(x => x === PRODUCTS.DigitalSignage);
    let digitalSignMenu = utility.getDigitalSignageMenu(digitalSignProduct, lang, user)

    let planningSubMenu = utility.getPlanningMenu(company, lang);

    const showLimimtedMediaManagementMenu = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.ShowLimitedMediaManagementMenu) ?? false;

    const genericMediaManagementLongFormMenu = [
        {
            type: 0,
            link: 'MediaEpisode/Series',
            modulesid: MODULE.MEDIA_EPISODE_SERIES,
            name: lang.series_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/Season',
            modulesid: MODULE.MEDIA_EPISODE_SEASON,
            name: lang.season_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/OrphanEpisode',
            modulesid: MODULE.MEDIA_EPISODE_SEASON,
            name: lang.episode_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/Program',
            modulesid: MODULE.MEDIA_EPISODE_PROGRAM,
            name: lang.program_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/Movie',
            modulesid: MODULE.MEDIA_EPISODE_MOVIE,
            name: lang.movie_sub_menu
        },
        !disableLiveEventSection && {
            type: 0,
            link: "LiveEvents",
            modulesid: MODULE.LIVE_EVENTS,
            name: lang.live_events_menu
        },
        !disableLiveEventSection && {
            type: 0,
            link: "Tournament",
            modulesid: MODULE.TOURNAMENT,
            name: lang.tournament_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/Trailer',
            modulesid: MODULE.MEDIA_EPISODE_TRAILER,
            name: lang.trailer_sub_menu
        }
    ];

    const minimilisticMediaManagementLongFormMenu = [
        {
            type: 0,
            link: 'MediaEpisode/AddProgram',
            modulesid: MODULE.MEDIA_EPISODE_SERIES,
            name: lang.add_program_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/SearchProgram',
            modulesid: MODULE.MEDIA_EPISODE_SERIES,
            name: lang.search_program_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/SearchProgramByCategory',
            modulesid: MODULE.MEDIA_EPISODE_SERIES,
            name: lang.search_program_by_category_sub_menu
        }
    ];

    const mediaManagementShortFormMenu = [
        {
            type: 0,
            link: 'MediaEpisode/Interstitial',
            modulesid: MODULE.MEDIA_EPISODE_INTERSTITIAL,
            name: lang.interstitial_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/Commercial',
            modulesid: MODULE.MEDIA_EPISODE_COMMERCIAL,
            name: lang.commercial_sub_menu
        },
        {
            type: 0,
            link: 'MediaEpisode/Filler',
            modulesid: MODULE.MEDIA_EPISODE_FILLER,
            name: lang.filler_sub_menu
        },
        {
            type: 1,
            title: lang.music_menu,
            icon: 'fa fa-lg fa-fw fa-plus-square-o',
            modulesid: MODULE.MEDIA_MANAGEMENT_MENU,
            name: lang.music_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'MediaEpisode/Music',
                    modulesid: MODULE.MEDIA_EPISODE_MUSIC,
                    name: lang.music_sub_menu
                },
                {
                    type: 0,
                    link: 'MusicCategory',
                    modulesid: MODULE.MUSIC_CATEGORY,
                    name: lang.music_category_sub_menu
                },
                {
                    type: 0,
                    link: "MusicPlaylist",
                    modulesid: MODULE.MUSIC_PLAYLIST,
                    name: lang.music_playlist_sub_menu
                }
            ]
        },
        {
            type: 1,
            title: lang.media_others_menu,
            icon: 'fa fa-lg fa-fw fa-plus-square-o',
            modulesid: MODULE.MEDIA_MANAGEMENT_MENU,
            name: lang.media_others_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'MediaEpisode/Break',
                    modulesid: MODULE.MEDIA_EPISODE_BREAK,
                    name: lang.break_sub_menu
                },
                {
                    type: 0,
                    link: 'MediaEpisode/Dummy',
                    modulesid: MODULE.MEDIA_EPISODE_DUMMY,
                    name: lang.dummy_sub_menu
                },
                {
                    type: 0,
                    link: "MediaEpisodeGroup",
                    modulesid: MODULE.MEDIA_EPISODE_GROUP,
                    name: lang.media_episode_group_sub_menu
                },
                {
                    type: 0,
                    link: "ProgramGroup",
                    modulesid: MODULE.PROGRAM_GROUP,
                    name: lang.program_group_sub_menu
                },
                {
                    type: 0,
                    link: "InterstitialGroup",
                    modulesid: MODULE.INTERSTITIAL_GROUP,
                    name: lang.interstitial_group_sub_menu
                },
                {
                    type: 0,
                    link: 'mamAssets',
                    modulesid: MODULE.MEDIA_EPISODE_MAMASSETS,
                    name: lang.mam_assets_sub_menu
                },

            ]
        },
        {
            type: 0,
            link: 'manageContent',
            modulesid: MODULE.MANAGE_CONTENT,
            name: lang.manage_content_menu,
            icon: 'fa fa-lg fa-fw fa-window-maximize'
        },
        {
            type: 0,
            link: 'mediaTemplate',
            modulesid: MODULE.Media_Template,
            name: lang.media_template_sub_menu
        },
        // {
        //     type: 0,
        //     link: 'trailerBooking',
        //     modulesid: MODULE.TRAILER_BOOKING,
        //     name: lang.trailer_booking_sub_menu
        // },
        {
            type: 0,
            link: 'promoCampaign',
            modulesid: MODULE.TRAILER_CAMPAIGN,
            name: lang.promo_campaign_sub_menu
        }
    ];

    const mediaManagementMenu = showLimimtedMediaManagementMenu ?
        [...minimilisticMediaManagementLongFormMenu, ...mediaManagementShortFormMenu] :
        [...genericMediaManagementLongFormMenu, ...mediaManagementShortFormMenu]

    return [
        {
            type: 0,
            link: 'Dashboard',
            modulesid: MODULE.DASHBOARD,
            name: lang.dashboard,
            icon: 'fa fa-lg fa-fw fa-tachometer-alt'
        },
        {
            type: 1,
            title: lang.user_favourite_menu,
            icon: 'fa fa-lg fa-fw fa-heart',
            modulesid: MODULE.CONTARCT_MENU,
            name: lang.user_favourite_menu,
            subMenu: subMenus

        },
        {
            type: 1,
            title: lang.contract_menu,
            icon: 'fa fa-lg fa-fw fa-file-pen ',
            modulesid: MODULE.CONTARCT_MENU,
            name: lang.contract_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'Contract',
                    modulesid: MODULE.CONTRACT,
                    name: lang.contract_sub_menu
                }
            ]
        },
        {
            type: 1,
            title: lang.media_management_menu,
            icon: 'fa fa-lg fa-fw fa-clapperboard',
            modulesid: MODULE.MEDIA_MANAGEMENT_MENU,
            name: lang.media_management_menu,
            subMenu: mediaManagementMenu

        },
        {
            type: 1,
            title: lang.mam_asset_menu,
            icon: 'fa fa-lg fa-fw fa-layer-group',
            modulesid: MODULE.MAM_ASSET_MENU,
            name: lang.mam_asset_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'mamAssets',
                    modulesid: MODULE.MEDIA_EPISODE_MAMASSETS,
                    name: lang.mam_assets_sub_menu
                },
                {
                    type: 0,
                    link: 'mamAssetsBeta',
                    modulesid: MODULE.MEDIA_EPISODE_MAMASSETS,
                    // name: lang.mam_assets_sub_menu
                    name: "Mam Asset Beta"
                },
                {
                    type: 0,
                    link: 'ingestPrototype',
                    modulesid: MODULE.INGEST_PROTOTYPE,
                    name: lang.ingest_prototype_sub_menu
                },
                {
                    type: 0,
                    link: 'transcodePrototypes',
                    modulesid: MODULE.TRANSCODE_PROTOTYPES,
                    name: lang.transcode_Prototypes_sub_menu
                }
            ]

        },
        {
            type: 0,
            link: 'contentTreeView',
            modulesid: MODULE.CONTENT_TREE_VIEW,
            name: lang.content_tree_view_menu,
            icon: 'fa fa-lg fa-fw fa-align-center'
        },
        {
            type: 1,
            title: lang.vod_sub_menu,
            icon: 'fa fa-lg fa-fw fa fa-window-restore',
            modulesid: MODULE.VOD_MENU,
            name: lang.vod_sub_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'nodeBrowser',
                    modulesid: MODULE.NODE_BROWSER,
                    name: lang.node_browser_menu,
                    icon: 'fa fa-lg fa-fw fa-file-o'
                },
                {
                    type: 0,
                    link: 'transmissionBrowser',
                    modulesid: MODULE.TRANSMISSION_BROWSER,
                    name: lang.transmission_browser_menu,
                    icon: 'fa fa-lg fa-fw fa fa-window-restore'
                },
                {
                    type: 0,
                    link: 'versionBrowser',
                    modulesid: MODULE.VERSION_BROWSER,
                    name: lang.version_browser_page_breadcrumb,
                    icon: 'fa fa-lg fa-fw fa fa-file-o'
                }
            ]
        },
        {
            type: 1,
            title: lang.planning_menu,
            //link: 'planning',
            modulesid: MODULE.PLANNING_MENU,
            name: lang.planning_menu,
            icon: 'fa fa-lg fa-fw fa-calendar-alt',
            subMenu: planningSubMenu
        },
        {
            type: 1,
            title: lang.scheduling_menu,
            //link: 'planning',
            modulesid: MODULE.SCHEDULING_MENU,
            name: lang.scheduling_menu,
            icon: 'fa fa-lg fa-fw fa-calendar-alt',
            subMenu: [
                {
                    type: 0,
                    link: 'Scheduling',
                    title: lang.scheduling_menu,
                    modulesid: MODULE.SCHEDULING,
                    target: '_blank',
                    //icon: 'fa fa-lg fa-fw fa-calendar-day',
                    name: lang.scheduling_menu,
                },
                {
                    type: 0,
                    link: 'missingmediareport',
                    modulesid: MODULE.MISSINGMEDIAREPORT,
                    name: lang.missing_media_report_sub_menu
                },
                {
                    type: 0,
                    link: 'breakConfiguration',
                    modulesid: MODULE.BREAKCONFIGURATION,
                    name: lang.break_configuration_sub_menu
                },
                {
                    type: 0,
                    link: 'scheduleExportHistory',
                    modulesid: MODULE.SCHEDULE_EXPORT_HISTORY,
                    name: lang.schedule_export_history_sub_menu
                },
                {
                    type: 0,
                    link: 'itXmlParser',
                    modulesid: MODULE.ITXML_PARSER,
                    name: lang.itxml_parser_sub_menu
                }
            ]
        },
        {
            type: 1,
            title: lang.publish_menu,
            //link: 'planning',
            modulesid: MODULE.PUBLISH_MENU,
            name: lang.publish_menu,
            icon: 'fa fa-lg fa-fw fa-file-powerpoint-o',
            subMenu: [
                {
                    type: 0,
                    link: 'publish',
                    title: lang.publish_menu,
                    modulesid: MODULE.PUBLISH,
                    name: lang.publish_menu,
                },
                {
                    type: 0,
                    link: 'vodCatalogueExport',
                    modulesid: MODULE.VOD_CATALOGUE_EXPORT,
                    name: lang.vod_catalogue_menu
                },
                {
                    type: 0,
                    link: 'epgsExport',
                    modulesid: MODULE.EPGS_EXPORT,
                    name: lang.epgs_menu
                },
                {
                    type: 0,
                    link: 'scheduleExport',
                    modulesid: MODULE.SCHEDULE_EXPORT,
                    name: lang.schedule_export_menu
                },
                {
                    type: 1,
                    title: lang.settings_label,
                    name: lang.settings_label,
                    subMenu: [
                        {
                            type: 0,
                            link: 'publish/provider',
                            title: lang.provider_sub_menu,
                            modulesid: MODULE.PUBLISH_PROVIDER,
                            name: lang.provider_sub_menu,
                        },
                        {
                            type: 0,
                            link: 'publish/settings',
                            title: lang.dai_configurations_sub_menu,
                            modulesid: MODULE.PUBLISH_SETTINGS,
                            name: lang.dai_configurations_sub_menu,
                        },
                    ]
                },
            ],
        },
        ...digitalSignMenu,
        {
            type: 0,
            link: 'timeline',
            title: lang.timeline_sub_menu,
            modulesid: MODULE.TIMELINE,
            name: lang.timeline_sub_menu,
            icon: 'fa fa-lg fa-fw fa-timeline'
        },
        {
            type: 0,
            link: 'timelineLinear',
            title: lang.timeline_linear_sub_menu,
            modulesid: MODULE.TIMELINE,
            name: lang.timeline_linear_sub_menu,
            icon: 'fa fa-lg fa-fw fa-timeline'
        },
        {
            type: 1,
            //link: '/OttPosters',
            title: lang.ingestion_menu,
            modulesid: MODULE.INGESTION_MENU,
            icon: 'fa fa-lg fa-fw fa-thin fa-indent',
            name: lang.ingestion_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'IngestionTemplate',
                    modulesid: MODULE.INGESTION_TEMPLATE,
                    name: lang.ingestion_template_sub_menu
                },
                {
                    type: 0,
                    link: 'PartnerIngetion',
                    modulesid: MODULE.PARTNER_INGESTION,
                    name: lang.partner_ingestion_sub_menu
                },
                {
                    type: 0,
                    link: 'Jobs',
                    modulesid: MODULE.JOBS,
                    name: lang.jobs_sub_menu
                },
                {
                    type: 0,
                    link: 'jobsSchedule',
                    modulesid: MODULE.JOBS_SCHEDULE,
                    name: lang.jobs_schedule_sub_menu
                },
                {
                    type: 0,
                    link: 'ingestionLogs',
                    modulesid: MODULE.INGESTION_LOGS,
                    name: lang.ingestion_logs_sub_menu
                }
            ]
        },
        {
            type: 1,
            title: lang.sales_menu,
            modulesid: MODULE.SALES_MENU,
            icon: 'fa fa-lg fa-fw fa-chart-bar',
            name: lang.sales_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'Agency',
                    modulesid: MODULE.AGENCY,
                    name: lang.agency_sub_menu
                },
                {
                    type: 0,
                    link: 'Client',
                    modulesid: MODULE.CLIENT,
                    name: lang.client_sub_menu
                },
                {
                    type: 0,
                    link: 'Campaign',
                    modulesid: MODULE.CAMPAIGN,
                    name: lang.campaign_sub_menu
                },
                {
                    type: 1,
                    title: lang.booking_sub_menu,
                    icon: 'fa fa-lg fa-fw fa-plus-square-o',
                    modulesid: MODULE.BOOKING,
                    name: lang.booking_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'Booking',
                            modulesid: MODULE.BOOKING,
                            name: lang.booking_sub_menu
                        },
                        {
                            type: 0,
                            link: 'YearlyBooking',
                            modulesid: MODULE.BOOKING,
                            name: lang.booking_yearly_sub_menu
                        },
                        {
                            type: 0,
                            link: 'BookingTransfer',
                            modulesid: MODULE.BOOKING_TRANSFER,
                            name: lang.booking_transfer_sub_menu
                        },
                        {
                            type: 0,
                            link: 'UpdateBookingLineNumber',
                            modulesid: MODULE.UPDATE_BOOKING_LINE_NUMBER,
                            name: lang.update_booking_line_number_sub_menu
                        },
                        {
                            type: 0,
                            link: 'MakeGoodSpot',
                            modulesid: MODULE.MAKE_GOOD_SPOT,
                            name: lang.makegoodspot_sub_menu
                        },

                    ]
                },
                {
                    type: 0,
                    link: 'Brand',
                    modulesid: MODULE.BRAND,
                    name: lang.brand_sub_menu
                },
                {
                    type: 0,
                    link: 'Product',
                    modulesid: MODULE.PRODUCT,
                    name: lang.product_sub_menu
                },
                {
                    type: 0,
                    link: 'Optimisation',
                    modulesid: MODULE.OPTIMISATION,
                    name: lang.optimisation_sun_menu
                },
                {
                    type: 0,
                    link: 'PendingApproval',
                    modulesid: MODULE.PENDING_APPROVAL,
                    name: lang.pending_approval_sun_menu
                },
                {
                    type: 0,
                    link: 'SalesTarget',
                    modulesid: MODULE.SALES_TARGET,
                    name: lang.sales_target_sub_menu
                },
                {
                    type: 0,
                    link: 'targetGroups',
                    modulesid: MODULE.TARGET_GROUPS,
                    name: lang.target_groups_sub_menu
                },
            ]
        },
        {
            type: 1,
            title: lang.social_media_menu,
            icon: 'fa fa-lg fa-fw fa-share-alt ',
            modulesid: MODULE.SOCIAL_MEDIA_MENU,
            name: lang.social_media_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'smDashboard',
                    modulesid: MODULE.SM_DASHBOARD,
                    name: lang.sm_dashboard_sub_menu
                },
                {
                    type: 0,
                    link: 'smChannel',
                    modulesid: MODULE.SM_CHANNELS,
                    name: lang.sm_channels_sub_menu
                },
                {
                    type: 0,
                    link: 'smBudgets',
                    modulesid: MODULE.SM_BUDGETS,
                    name: lang.budget_sub_menu
                },
                {
                    type: 0,
                    link: 'smCampaign',
                    modulesid: MODULE.SM_CAMPAIGN,
                    name: lang.sm_campaigns_sub_menu
                },
                {
                    type: 0,
                    link: 'smAds',
                    modulesid: MODULE.SM_ADS,
                    name: lang.ads_sub_menu
                },
                {
                    type: 0,
                    link: 'smAudience',
                    modulesid: MODULE.SM_AUDIENCE,
                    name: lang.audience_sub_menu
                },
                {
                    type: 1,
                    title: lang.promotions_sub_menu,
                    icon: 'fa fa-lg fa-fw fa-bullhorn',
                    modulesid: MODULE.SM_PROMOTIONS,
                    name: lang.promotions_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'smPromotionsPages',
                            modulesid: MODULE.SM_PROMOTIONS_PAGES,
                            name: lang.pages_sub_menu
                        },
                        {
                            type: 0,
                            link: 'smPromotionsCampaigns',
                            modulesid: MODULE.SM_PROMOTIONS_CAMPAIGNS,
                            name: lang.campaign_sub_menu
                        },
                        {
                            type: 0,
                            link: 'smPromotionsPosts',
                            modulesid: MODULE.SM_PROMOTIONS_POSTS,
                            name: lang.post_sub_menu
                        },
                        {
                            type: 0,
                            link: 'smPromotionsSchedule',
                            modulesid: MODULE.SM_PROMOTIONS_SCHEDULE,
                            name: lang.sm_promotions_schedule_menu
                        },
                         {
                            type: 0,
                            link: 'smPromotionRevenueReport',
                            modulesid: MODULE.SM_PROMOTION_REVENUE_REPORT,
                            name: lang.sm_revenue_report_menu
                        },
                    ]
                },
            ]
        },
        {
            type: 1,
            title: lang.reconciliation_menu,
            icon: 'fa fa-lg fa-fw fa-download ',
            modulesid: MODULE.IMPORT_MENU,
            name: lang.reconciliation_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'ScheduleReconciliation',
                    modulesid: MODULE.SCHEDULE_RECONCILIATION,
                    name: lang.as_run_reconciliation_sub_menu
                },
                {
                    type: 0,
                    link: 'AnnouncementReconcile',
                    modulesid: MODULE.ANNOUNCEMENT_RECONCILE,
                    name: lang.announcement_reconcile_sun_menu
                },
                {
                    type: 0,
                    link: 'ImportAsRun',
                    modulesid: MODULE.IMPORT_AS_RUN,
                    name: lang.import_asRun_sub_menu
                },
                {
                    type: 0,
                    link: 'ManageAsRun',
                    modulesid: MODULE.MANAGE_AS_RUN,
                    name: lang.manage_asRun_sub_menu
                }
            ]
        },
        {
            type: 1,
            title: lang.secondary_event_menu,
            icon: 'fa fa-lg fa-fw fa-thin fa-pager',
            modulesid: MODULE.SECONDARY_EVENT_MENU,
            name: lang.secondary_event_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'SecondaryEventPrototype',
                    modulesid: MODULE.SECONDARY_EVENT_PROTOTYPE,
                    name: lang.prototype_sub_menu
                },
                {
                    type: 0,
                    link: 'SecondaryEventStyleSheet',
                    modulesid: MODULE.SECONDARY_EVENT_STYLE_SHEET,
                    name: lang.styleSheet_sub_menu
                },
                {
                    type: 0,
                    link: 'DefaultSecondaryEventPrototype',
                    modulesid: MODULE.DEFAULT_SECONDARY_EVENT_PROTOTYPR,
                    name: lang.default_prototype_sub_menu
                },
                {
                    type: 0,
                    link: 'ProtoTypeSource',
                    modulesid: MODULE.PROTO_TYPE_SOURCE,
                    name: lang.protoType_source_sub_menu
                },
                {
                    type: 0,
                    link: 'SecondaryEventDynamicRule',
                    modulesid: MODULE.SECONDARY_EVENT_DYNAMIC_RULE,
                    name: lang.secondary_event_dynamic_rule_sub_menu
                }

            ]
        },
        {
            type: 1,
            title: lang.billing_menu,
            modulesid: MODULE.BILLING_MENU,
            icon: 'fa fa-lg fa-fw fa-thin fa-pager',
            name: lang.billing_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'BillingCollection',
                    modulesid: MODULE.BILLING,
                    name: lang.billing_sub_menu
                },

                {
                    type: 0,
                    link: 'GeneratedBillCollection',
                    modulesid: MODULE.GENERATE_BILL,
                    name: lang.generated_bills_sub_menu
                },
                {
                    type: 0,
                    link: 'billingsummaryreport',
                    modulesid: MODULE.BILLINGSUMMARYREPORT,
                    name: lang.billing_summary_report_sub_menu
                }

            ]
        },
        {
            type: 1,
            title: lang.curate_menu,
            name: lang.curate_menu,
            modulesid: MODULE.CURATE_MENU,
            icon: 'fa fa-lg fa-fw fa-thin fa-sitemap',
            subMenu: [
                {
                    type: 0,
                    icon: 'fa fa-lg fa-fw fa-thin fa-pager ',
                    link: 'OttMenu',
                    modulesid: MODULE.OTTMENU,
                    name: lang.ottmenu_sub_menu
                },
                {
                    type: 0,
                    icon: 'fa fa-lg fa-fw fa-thin fa-pager ',
                    link: 'Page',
                    modulesid: MODULE.PAGE,
                    name: lang.pages_sub_menu
                },
                {
                    type: 0,
                    icon: 'fa fa-lg fa-fw fa-thin fa-trailer ',
                    link: 'Rails',
                    modulesid: MODULE.RAILS,
                    name: lang.rails_sub_menu
                },
                {
                    type: 0,
                    link: 'OttAssets',
                    modulesid: MODULE.OTT_ASSETS,
                    name: lang.assets_sub_menu
                },
                {
                    type: 0,
                    link: 'upComingEvents',
                    modulesid: MODULE.UPCOMING_EVENTS,
                    name: lang.upcoming_events_sub_menu
                },
                {
                    type: 0,
                    link: 'OttCampaign',
                    modulesid: MODULE.OTT_CAMPAIGN,
                    name: lang.ott_campaign_sub_menu
                },
                {
                    type: 0,
                    link: 'OttPosters',
                    modulesid: MODULE.OTT_POSTERS,
                    name: lang.posters_sub_menu
                },
                {
                    type: 0,
                    link: 'ottprovider',
                    modulesid: MODULE.OTT_PROVIDER,
                    name: lang.provider_sub_menu
                },
                {
                    type: 0,
                    link: 'document',
                    modulesid: MODULE.DOCUMENT,
                    name: lang.document_sub_menu
                },

                {
                    type: 1,
                    title: lang.preview_menu,
                    name: lang.preview_menu,
                    modulesid: MODULE.TV,
                    icon: 'fa fa-lg fa-fw fa-thin fa-eye',
                    subMenu: [
                        {
                            type: 0,
                            title: lang.tv_preview_sub_menu,
                            modulesid: MODULE.TV,
                            name: lang.tv_preview_sub_menu,
                            link: 'tv'
                        },
                        {
                            type: 0,
                            title: lang.mobile_preview_sub_menu,
                            modulesid: MODULE.MOBILE,
                            name: lang.mobile_preview_sub_menu,
                            link: 'mobile'
                        },
                        {
                            type: 0,
                            title: lang.web_preview_sub_menu,
                            modulesid: MODULE.TV,
                            name: lang.web_preview_sub_menu,
                            link: 'tv'
                        },
                    ]

                },
                {
                    type: 0,
                    link: 'faq',
                    modulesid: MODULE.FAQ,
                    name: lang.faq_sub_menu
                },
                {
                    type: 0,
                    link: 'tutorialvideos',
                    modulesid: MODULE.TUTORIAL_VIDEOS,
                    name: lang.tutorial_videos_sub_menu
                },
                {
                    type: 0,
                    link: 'marketingScreens/1',
                    modulesid: MODULE.MARKETINGSCREENS,
                    name: lang.marketing_screens_sub_menu
                },
                {
                    type: 0,
                    link: 'promotionalScreens/1',
                    modulesid: MODULE.PROMOTIONALSCREENS,
                    name: lang.promotional_screens_sub_menu
                },
                {
                    type: 0,
                    icon: 'fa fa-lg fa-fw fa-thin fa-pager ',
                    link: 'WebAssets',
                    modulesid: MODULE.WEB_ASSETS,
                    name: lang.web_assets_sub_menu
                },
                {
                    type: 0,
                    link: 'screensaver/7',
                    modulesid: MODULE.SCREEN_SAVER,
                    name: lang.screen_saver_sub_menu
                },
                {
                    type: 0,
                    link: 'theme',
                    modulesid: MODULE.THEME,
                    name: lang.theme_sub_menu
                },
                {
                    type: 0,
                    icon: 'fa fa-lg fa-fw fa-thin fa-pager ',
                    link: 'OttSetting',
                    modulesid: MODULE.OTTSETTING,
                    name: lang.ott_setting_sub_menu
                },
                //  Not Complete yet

                {
                    type: 0,
                    link: 'pipagesetting',
                    modulesid: MODULE.PI_PAGE_SETTING,
                    name: lang.pi_page_setting_sub_menu
                },
                {
                    type: 0,
                    link: 'contentDistribution',
                    modulesid: MODULE.CONTENT_DISTRIBUTION,
                    name: lang.content_distribution_sub_menu
                },
                {
                    type: 0,
                    link: 'ottAggregator',
                    modulesid: MODULE.OTT_AGGREGATOR,
                    name: lang.ott_aggregator_sub_menu
                }
            ]
        },
        {
            type: 1,
            title: lang.dai_ad_insertions_menu,
            name: lang.dai_ad_insertions_menu,
            modulesid: MODULE.DAI,
            icon: 'fa fa-lg fa-fw fa-thin fa-audio-description',
            subMenu: [
                {
                    type: 0,
                    icon: 'fa fa-lg fa-fw fa-thin fa-pager',
                    link: 'DaiChannel',
                    modulesid: MODULE.DAI_CHANNEL,
                    name: lang.dai_channels_sub_menu
                },
                {
                    type: 1,
                    title: lang.configuration_label,
                    name: lang.configuration_label,
                    modulesid: MODULE.DAI_CONFIGURATION,
                    icon: 'fa fa-lg fa-fw fa-thin fa-sun-o',
                    subMenu: [
                        {
                            type: 0,
                            link: 'DaiInput',
                            modulesid: MODULE.DAI_INPUTS,
                            name: lang.inputs_sub_menu
                        },
                        {
                            type: 0,
                            link: 'DaiOutput',
                            modulesid: MODULE.DAI_OUTPUTS,
                            name: lang.outputs_sub_menu
                        },
                        {
                            type: 0,
                            link: 'DaiTranscoding',
                            modulesid: MODULE.DAI_TRANSCODING,
                            name: lang.dai_transcodings_sub_menu
                        },
                        {
                            type: 0,
                            link: 'DaiAdInsertion',
                            modulesid: MODULE.DAI_AD_INSERTION,
                            name: lang.dai_ad_insertions_sub_menu
                        },
                    ]

                },
            ]

        },
        {
            type: 1,
            title: lang.monetization_menu,
            modulesid: MODULE.MONETIZATION,
            icon: 'fa fa-lg fa-fw fa-th-list',
            name: lang.monetization_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'OttProduct',
                    modulesid: MODULE.OTT_PRODUCT,
                    name: lang.ott_product_sub_menu
                },
                {
                    type: 0,
                    link: 'PaymentPlan',
                    modulesid: MODULE.PAYMENT_PLAN,
                    name: lang.paymentPlan_sub_menu
                },
                {
                    type: 0,
                    link: 'Coupon',
                    modulesid: MODULE.COUPON,
                    name: lang.coupon_sub_menu
                },
                {
                    type: 0,
                    link: 'Subscriber',
                    modulesid: MODULE.SUBSCRIBER,
                    name: lang.subscriber_sub_menu
                },
                {
                    type: 0,
                    link: 'OttPeriod',
                    modulesid: MODULE.OTT_PERIOD,
                    name: lang.ott_period_sub_menu
                },
                {
                    type: 0,
                    link: "PaymentProvider",
                    modulesid: MODULE.PAYMENT_PROVIDER,
                    name: lang.payment_provider_sub_menu
                },
                {
                    type: 0,
                    link: "AvodConfiguration",
                    modulesid: MODULE.AVOD_CONFIGURATION,
                    name: lang.avod_Configuration_sub_menu
                },
                {
                    type: 0,
                    link: "analyticsProvider",
                    modulesid: MODULE.ANALYTICS_PROVIDER,
                    name: lang.analytics_providers_sub_menu
                },
                {
                    type: 0,
                    link: "analyticsEvents",
                    modulesid: MODULE.ANALYTICS_EVENTS,
                    name: lang.analytics_events_sub_menu
                },
                {
                    type: 0,
                    link: "pricecode",
                    modulesid: MODULE.PRICE_CODE,
                    name: lang.price_code_sub_menu
                },
                {
                    type: 0,
                    link: "offer",
                    modulesid: MODULE.OFFER,
                    name: lang.offer_sub_menu
                },

            ]
        },
        {
            type: 1,
            title: lang.bucket_configurations_menu,
            icon: "fa fa-bucket",
            modulesid: MODULE.BUCKET_CONFIGURATIONS_MENU,
            name: lang.bucket_configurations_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'bucket',
                    modulesid: MODULE.BUCKETS,
                    name: lang.bucket_sub_menu
                },
                {
                    type: 0,
                    link: 'bucketConfiguration',
                    modulesid: MODULE.BUCKET_CONFIGURATIONS,
                    name: lang.bucket_configurations_sub_menu
                },
            ]

        },
        {
            type: 1,
            title: lang.notification_menu,
            icon: "fa fa-bell",
            modulesid: MODULE.NOTIFICATION_MENU,
            name: lang.notification_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'notificationManager',
                    modulesid: MODULE.NOTIFICATION_MANAGER,
                    name: lang.notification_manager_sub_menu
                },
            ]

        },
        {
            type: 1,
            title: lang.service_menu,
            icon: 'fa fa-lg fa-fw fa-servicestack ',
            modulesid: MODULE.SERVICE_MENU,
            name: lang.service_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'amazondeliverygroup',
                    modulesid: MODULE.AMAZONDELIVERYGROUP,
                    name: lang.amazon_delivery_group_sub_menu
                },
                {
                    type: 0,
                    link: 'ottpackagedeliveryschedule',
                    modulesid: MODULE.OTT_PACKAGE_DELIVERY_SCHEDULE,
                    name: lang.ott_package_delivery_schedule_menu
                },
                {
                    type: 0,
                    link: 'scheduleautofillinterstitial',
                    modulesid: MODULE.SCHEDULE_AUTO_FILL_INTERSTITIAL,
                    name: lang.schedule_auto_fill_interstitial_sub_menu
                },
            ]
        },
        {
            type: 1,
            title: lang.export_menu,
            icon: 'fa fa-lg fa-fw fa-file-export ',
            modulesid: MODULE.EXPORT_MENU,
            name: lang.export_menu,
            subMenu: [
                {
                    type: 0,
                    link: 'exportepgreport',
                    modulesid: MODULE.EXPORT_EPG_REPORT,
                    name: lang.epg_sub_menu
                },
                {
                    type: 0,
                    link: 'exportepgtemplate',
                    modulesid: MODULE.EXPORT_EPG_TEMPLATE,
                    name: lang.epg_template_sub_menu
                },
                {
                    type: 0,
                    link: 'exportmanagecontenttemplate',
                    modulesid: MODULE.MANAGE_CONTENT_EXPORT_TEMPLATE,
                    name: lang.manage_content_template_sub_menu
                },
            ]
        },
        {
            type: 1,
            title: lang.master_menu_title,
            modulesid: MODULE.MASTER_MENU,
            icon: 'fa fa-lg fa-fw fa-box',
            name: lang.masters_menu,
            subMenu: [
                {
                    type: 1,
                    title: lang.traffic_sub_menu,
                    icon: 'fa fa-lg fa-fw fa-plus-square-o',
                    modulesid: MODULE.MEDIA_EPISODE_SERIES,
                    // modulesid: MODULE.TRAFFIC_SUB_MENU,
                    name: lang.traffic_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: "amortizationRule",
                            modulesid: MODULE.AMORTIZATION_RULE,
                            name: lang.amortization_rule_sub_menu
                        },
                        {
                            type: 0,
                            link: 'AudioCodec',
                            modulesid: MODULE.AUDIOCODEC,
                            name: lang.audio_codec_sub_menu
                        },
                        {
                            type: 0,
                            link: 'autoSegmentRule',
                            modulesid: MODULE.AUTO_SEGMENT_RULE,
                            name: lang.auto_segment_rule_sub_menu
                        },
                        {
                            type: 0,
                            link: "BreakFormat",
                            modulesid: MODULE.BREAKFORMAT,
                            name: lang.break_format_sub_menu
                        },
                        {
                            type: 0,
                            link: 'casttype',
                            modulesid: MODULE.CASTTYPE,
                            name: lang.cast_Type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'catalogues',
                            modulesid: MODULE.CATALOGUES,
                            name: lang.catalogues_sub_menu
                        },
                        {
                            type: 0,
                            link: 'censorRating',
                            modulesid: MODULE.CENSORRATING,
                            name: lang.censor_rating_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Channel',
                            modulesid: MODULE.CHANNEL,
                            name: lang.channel_sub_menu
                        },
                        {
                            type: 0,
                            link: 'channelGroups',
                            modulesid: MODULE.CHANNEL_GROUPS,
                            name: lang.channel_groups_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Content',
                            modulesid: MODULE.CONTENT,
                            name: lang.content_sub_menu
                        },
                        {
                            type: 0,
                            link: 'CopySlotPrototype',
                            modulesid: MODULE.COPY_SLOT_PROTOTYPE,
                            name: lang.copy_slot_prototype_sub_menu
                        },
                        {
                            type: 0,
                            link: 'ContentCategory',
                            modulesid: MODULE.CONTENT_CATEGORY,
                            name: lang.content_category_sub_menu
                        },
                        {
                            type: 0,
                            link: 'contractType',
                            modulesid: MODULE.CONTRACT_TYPE,
                            name: lang.contract_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Countries',
                            modulesid: MODULE.COUNTRIES,
                            name: lang.countries_sub_menu
                        },
                        {
                            type: 0,
                            link: 'dayPart',
                            modulesid: MODULE.DAYPART,
                            name: lang.day_part_sub_menu
                        },
                        {
                            type: 0,
                            link: 'DeliveryMethod',
                            modulesid: MODULE.DELIVERY_METHOD,
                            name: lang.delivery_method_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Department',
                            modulesid: MODULE.DEPARTMENT,
                            name: lang.department_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Genre',
                            modulesid: MODULE.GENRE,
                            name: lang.genre_sub_menu
                        },
                        {
                            type: 0,
                            link: 'genreSubGenreMapping',
                            modulesid: MODULE.GENRE_SUBGENRE_MAPPING,
                            name: lang.genre_subgenre_mapping_sub_menu
                        },
                        {
                            type: 0,
                            link: 'imageGroups',
                            modulesid: MODULE.IMAGE_GROUPS,
                            name: lang.image_groups_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Language',
                            modulesid: MODULE.LANGAUGE,
                            name: lang.language_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Licensor',
                            modulesid: MODULE.LICENSOR,
                            name: lang.licensor_sub_menu
                        },
                        {
                            type: 0,
                            link: 'LiveEventRound',
                            modulesid: MODULE.LiveEventRound,
                            name: lang.live_event_round_sub_menu
                        },
                        {
                            type: 0,
                            link: 'LiveEventType',
                            modulesid: MODULE.LiveEventType,
                            name: lang.LiveEventType_sub_menu
                        },
                        {
                            type: 0,
                            link: 'matchType',
                            modulesid: MODULE.MATCHTYPE,
                            name: lang.match_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'MaterialContent',
                            modulesid: MODULE.MATERIALCONTENT,
                            name: lang.material_content_sub_menu
                        },
                        {
                            type: 0,
                            link: 'MediaCategoryType',
                            modulesid: MODULE.MEDIACATEGORYTYPE,
                            name: lang.media_category_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'MediaSubCategoryType',
                            modulesid: MODULE.MEDIASUBCATEGORYTYPE,
                            name: lang.media_sub_category_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'nodes',
                            modulesid: MODULE.NODES,
                            name: lang.nodes_sub_menu
                        },
                        {
                            type: 0,
                            link: 'PGRating',
                            modulesid: MODULE.PGRATING,
                            name: lang.pgrating_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Pincodes',
                            modulesid: MODULE.PINCODS,
                            name: lang.pincode_sub_menu
                        },
                        {
                            type: 0,
                            link: 'platformGroups',
                            modulesid: MODULE.PLATFORM_GROUPS,
                            name: lang.platform_groups_sub_menu
                        },
                        {
                            type: 0,
                            link: 'protoTypeContent',
                            modulesid: MODULE.PROTO_TYPE_CONTENT,
                            name: lang.prototypecontent_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Region',
                            modulesid: MODULE.REGION,
                            name: lang.region_sub_menu
                        },
                        {
                            type: 0,
                            link: 'resolution',
                            modulesid: MODULE.RESOLUTION,
                            name: lang.resolution_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Role',
                            modulesid: MODULE.ROLE,
                            name: lang.role_sub_menu
                        },
                        {
                            type: 0,
                            link: "ScheduleConstraints",
                            modulesid: MODULE.SCHEDULE_CONSTRAINTS,
                            name: lang.schedule_constraints_sub_menu
                        },
                        {
                            type: 0,
                            link: 'SegmentType',
                            modulesid: MODULE.SEGMENT_TYPE,
                            name: lang.segemnt_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'SimulcastChannelConfig',
                            modulesid: MODULE.SIMULCAST_CHANNEL_CONFI,
                            name: lang.simul_cast_channel_configuration_sub_menu
                        },
                        {
                            type: 0,
                            link: 'States',
                            modulesid: MODULE.STATES,
                            name: lang.states_sub_menu
                        },
                        {
                            type: 0,
                            link: 'targetTypes',
                            modulesid: MODULE.TARGET_TYPES,
                            name: lang.target_types_sub_menu
                        },
                        {
                            type: 0,
                            link: 'TechnicalDetailPrototype',
                            modulesid: MODULE.TECHNICAL_DETAILS_PROTOTYPE,
                            name: lang.technical_details_prototype_sub_menu
                        },
                        {
                            type: 0,
                            link: 'timezone',
                            modulesid: MODULE.TIMEZONE,
                            name: lang.time_zone_sub_menu
                        },
                        {
                            type: 0,
                            link: 'TournamentType',
                            modulesid: MODULE.TournamentType,
                            name: lang.TournamentType_sub_menu
                        },
                        {
                            type: 0,
                            link: 'tournamentGroup',
                            modulesid: MODULE.TOURNAMENTGROUP,
                            name: lang.tournament_group_sub_menu
                        },
                        {
                            type: 0,
                            link: 'TxMode',
                            modulesid: MODULE.TX_MODE,
                            name: lang.tx_mode_sub_menu
                        },
                        {
                            type: 0,
                            link: 'TxStatus',
                            modulesid: MODULE.TX_STATUS,
                            name: lang.tx_status_sub_menu
                        },
                        {
                            type: 0,
                            link: "transmissiontypes",
                            modulesid: MODULE.TRANSMISSION_TYPES,
                            name: lang.transmission_types_sub_menu
                        },
                        {
                            type: 0,
                            link: "transcodeDefinition",
                            modulesid: MODULE.TRANSCODE_DEFINITION,
                            name: lang.transcode_definition_sub_menu
                        },
                        {
                            type: 0,
                            link: 'users',
                            modulesid: MODULE.USERS,
                            name: lang.users_sub_menu
                        },
                        {
                            type: 0,
                            link: "Variation",
                            modulesid: MODULE.VARIATION,
                            name: lang.variation_sub_menu
                        },
                        {
                            type: 0,
                            link: "variance",
                            modulesid: MODULE.VARIANCE,
                            name: lang.variance_sub_menu
                        },
                        {
                            type: 0,
                            link: "Version",
                            modulesid: MODULE.VERSION,
                            name: lang.version_sub_menu
                        },
                        {
                            type: 0,
                            link: "VideoAspectRatio",
                            modulesid: MODULE.VIDEO_ASPECT_RATIO,
                            name: lang.video_aspect_ratio_sub_menu
                        },
                        {
                            type: 0,
                            link: "VideoCodec",
                            modulesid: MODULE.VIDEOCODEC,
                            name: lang.video_codec_sub_menu
                        },
                        {
                            type: 0,
                            link: "VideoType",
                            modulesid: MODULE.VIDEOTYPE,
                            name: lang.video_type_sub_menu
                        }
                    ]
                },
                {
                    type: 1,
                    title: lang.adSales_sub_menu,
                    icon: 'fa fa-lg fa-fw fa-plus-square-o',
                    modulesid: MODULE.BOOKING,
                    // modulesid: MODULE.AD_SALES_SUB_MENU,
                    name: lang.adSales_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'AgencyType',
                            modulesid: MODULE.AGENCY_TYPE,
                            name: lang.agency_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'BankAccount',
                            modulesid: MODULE.BANK_ACCOUNT,
                            name: lang.bank_account_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Brand',
                            modulesid: MODULE.BRAND,
                            name: lang.brand_sub_menu
                        },
                        {
                            type: 0,
                            link: 'campaignCategory',
                            modulesid: MODULE.CAMPAIGN_CATEGORY,
                            name: lang.campaign_category_sub_menu
                        },
                        {
                            type: 0,
                            link: 'campaigntype',
                            modulesid: MODULE.CAMPAIGNTYPE,
                            name: lang.campaigntype_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Currency',
                            modulesid: MODULE.CURRENCY,
                            name: lang.currency_sub_menu
                        },
                        {
                            type: 0,
                            link: 'dealtype',
                            modulesid: MODULE.DEALTYPE,
                            name: lang.dealtype_sub_menu
                        },
                        {
                            type: 0,
                            link: 'FinancialYear',
                            modulesid: MODULE.FINANCIAL_YEAR,
                            name: lang.financial_year_sub_menu
                        },
                        {
                            type: 0,
                            link: 'InvoiceContent',
                            modulesid: MODULE.INVOICE_CONTENT,
                            name: lang.invoice_content_sub_menu
                        },
                        {
                            type: 0,
                            link: 'location',
                            modulesid: MODULE.LOCATION,
                            name: lang.location_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Product',
                            modulesid: MODULE.PRODUCT,
                            name: lang.product_sub_menu
                        },
                        {
                            type: 0,
                            link: 'ratecard',
                            modulesid: MODULE.RATECARD,
                            name: lang.ratecard_sun_menu
                        },
                        {
                            type: 0,
                            link: 'SalesTeam',
                            modulesid: MODULE.SALES_TEAM,
                            name: lang.sales_team_sub_menu
                        },
                        {
                            type: 0,
                            link: 'users/SalesExecutive',
                            modulesid: MODULE.SALES_EXECUTIVE,
                            name: lang.sales_executive_sub_menu
                        },
                        {
                            type: 0,
                            link: "SponsorType",
                            modulesid: MODULE.SPONSOR_TYPE,
                            name: lang.sponsor_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'Tax',
                            modulesid: MODULE.TAX,
                            name: lang.tax_sub_menu
                        },
                        {
                            type: 0,
                            link: 'timerange',
                            modulesid: MODULE.TIME_RANGE,
                            name: lang.time_range_sub_menu
                        }
                    ]
                },
                {
                    type: 1,
                    title: lang.curate_sub_menu,
                    icon: 'fa fa-lg fa-fw fa-plus-square-o',
                    modulesid: MODULE.OTT_ASSETS,
                    // modulesid: MODULE.CMS_SUB_MENU,
                    name: lang.curate_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'OttAssetType',
                            modulesid: MODULE.ASSETS_TYPE,
                            name: lang.assets_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'faqcategory',
                            modulesid: MODULE.FAQCATEGORY,
                            name: lang.faq_category_sub_menu
                        },
                        {
                            type: 0,
                            link: 'OttPosterType',
                            modulesid: MODULE.POSTERS_TYPE,
                            name: lang.posters_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'ottPlatform',
                            modulesid: MODULE.PLATFORM,
                            name: lang.ott_platform_sub_menu
                        },
                    ]
                },
                {
                    type: 1,
                    title: lang.monetize_sub_menu,
                    icon: 'fa fa-lg fa-fw fa-plus-square-o',
                    modulesid: MODULE.PAYMENT_PLAN,
                    // modulesid: MODULE.MONETIZE_SUB_MENU,
                    name: lang.monetize_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: "OttPeriodType",
                            modulesid: MODULE.OTT_PERIOD_TYPE,
                            name: lang.ott_period_type_sub_menu
                        },
                        {
                            type: 0,
                            link: "PaymentType",
                            modulesid: MODULE.PAYMENT_TYPE,
                            name: lang.payment_type_sub_menu
                        },
                        {
                            type: 0,
                            link: 'OttSegment',
                            modulesid: MODULE.OTT_SEGMENT,
                            name: lang.ott_segment_sub_menu
                        },
                    ]
                },
                {
                    type: 1,
                    title: lang.message_sub_menu,
                    modulesid: MODULE.MESSAGE_SUB_MENU,
                    icon: 'fa fa-lg fa-fw fa-plus-square-o',
                    name: lang.message_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: "messageProvider",
                            modulesid: MODULE.MESSAGE_PROVIDER,
                            name: lang.message_provider_sub_menu
                        },
                        {
                            type: 0,
                            link: "messageTemplate",
                            modulesid: MODULE.MESSAGE_TEMPLATE,
                            name: lang.message_template_sub_menu
                        },
                        {
                            type: 0,
                            link: "messageConfiguration",
                            modulesid: MODULE.MESSAGE_CONFIGURATION,
                            name: lang.message_configuration_sub_menu
                        }

                    ]
                }
            ]
        },
        {
            type: 1,
            title: lang.report_menu,
            icon: 'fa fa-lg fa-fw fa-clipboard',
            modulesid: MODULE.REPORTS_MENU,
            name: lang.report_menu,
            link: 'report',
            subMenu: [
                {
                    type: 0,
                    link: 'acquitionReport',
                    modulesid: MODULE.ACQUITION_REPORT,
                    name: lang.acquition_report_sub_menu
                },
                {
                    type: 0,
                    link: 'airtimeconsumptionreport',
                    modulesid: MODULE.AIRTIMECONSUMPTIONREPORT,
                    name: lang.air_time_consumption_report_sub_menu
                },
                {
                    type: 0,
                    link: 'BookingScheduleStatus',
                    modulesid: MODULE.BOOKING_SCHEDULE_STATUS,
                    name: lang.booking_schedule_status_sub_menu
                },
                {
                    type: 0,
                    link: 'brandProductReport',
                    modulesid: MODULE.BRAND_PRODUCT_REPORT,
                    name: lang.brand_product_report_sub_menu
                },
                {
                    type: 0,
                    link: 'campaignReport',
                    modulesid: MODULE.CAMPAIGN_REPORT,
                    name: lang.campaign_report_sub_menu
                },
                {
                    type: 0,
                    link: 'clientagencybookingreport',
                    modulesid: MODULE.CLIENTAGENCYBOOKINGREPORT,
                    name: lang.client_agency_booking_report_sub_menu
                },
                {
                    type: 0,
                    link: 'creditlinereport',
                    modulesid: MODULE.CREDITLINEREPORT,
                    name: lang.credit_line_report_sub_menu
                },
                {
                    type: 0,
                    link: 'commercialConsumptionReport',
                    modulesid: MODULE.COMMERCIAL_CONSUMPTION_REPORT,
                    name: lang.commercial_consumption_report_sub_menu
                },
                {
                    type: 0,
                    link: 'interstitialhistoryreport',
                    modulesid: MODULE.INTERSTITIAL_HISTORY_REPORT,
                    name: lang.interstitial_history_sub_menu
                },
                {
                    type: 0,
                    link: 'MediaMasterReport',
                    modulesid: MODULE.MEDIA_MASTER_REPORT,
                    name: lang.media_master_report_sub_menu
                },
                {
                    type: 0,
                    link: 'exportmediacontentreport',
                    // modulesid: MODULE.EXPORT_EPG_REPORT,
                    modulesid: MODULE.MEDIA_MASTER_REPORT,
                    name: lang.media_content_report_sub_menu
                },
                {
                    type: 0,
                    link: 'musicReport',
                    modulesid: MODULE.MUSIC_REPORT,
                    name: lang.music_report_sub_menu
                },
                {
                    type: 0,
                    link: 'musicAiringReport',
                    modulesid: MODULE.MUSIC_AIRING_REPORT,
                    name: lang.music_airing_report_sub_menu
                },
                {
                    type: 0,
                    link: 'mediaActualDurationReport',
                    modulesid: MODULE.MEDIA_ACTUAL_DURATION_REPORT,
                    name: lang.media_actual_duration_sub_menu
                },
                {
                    type: 0,
                    link: 'prelogpostlogreport',
                    modulesid: MODULE.PRELOGPOSTLOGREPORT,
                    name: lang.prelog_postlog_report_sub_menu
                },
                {
                    type: 0,
                    link: 'programTimeConsumptionReport',
                    modulesid: MODULE.PROGRAM_TIME_CONSUMPTION_REPORT,
                    name: lang.program_time_consumption_report_sub_menu
                },
                {
                    type: 0,
                    link: 'purgespotreport',
                    modulesid: MODULE.PURGESPOTREPORT,
                    name: lang.purge_Spot_report_sub_menu
                },
                {
                    type: 0,
                    link: 'programLastAiringReport',
                    modulesid: MODULE.PROGRAM_LAST_AIRING_REPORT,
                    name: lang.program_last_airing_sub_menu
                },
                {
                    type: 0,
                    link: 'ingestionReport',
                    modulesid: MODULE.INGESTION_REPORT,
                    name: lang.ingestion_report_sub_menu
                },
                {
                    type: 0,
                    link: 'breakPatternReport',
                    modulesid: MODULE.BREAK_PATTERN_REPORT,
                    name: lang.break_pattern_report_sub_menu
                },
                {
                    type: 0,
                    link: "vodMasterTrackerReport",
                    modulesid: MODULE.VOD_MASTER_TRACKER_REPORT,
                    name: lang.vod_master_tracker_report_sub_menu
                },
                {
                    type: 0,
                    link: "urfReport",
                    modulesid: MODULE.URF_REPORT,
                    name: lang.urf_report_sub_menu
                },
                {
                    type: 1,
                    link: 'report/mam',
                    modulesid: MODULE.MAM_SUBMENU_REPORT,
                    name: lang.mam_report_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'MamAssetReport',
                            modulesid: MODULE.MAM_ASSET_REPORT,
                            name: lang.mam_asset_report_sub_menu
                        },
                        {
                            type: 0,
                            link: 'dublistReport',
                            modulesid: MODULE.DUBLIST_REPORT,
                            name: lang.dublist_report_sub_menu
                        },
                        {
                            type: 0,
                            link: 'purgeListReport',
                            modulesid: MODULE.PURGE_LIST_REPORT,
                            name: lang.purge_list_report_sub_menu
                        }
                    ]
                },
                {
                    type: 1,
                    link: 'report/vod',
                    modulesid: MODULE.VOD_SUBMENU_REPORT,
                    name: lang.vod_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'vodreport',
                            modulesid: MODULE.VOD_REPORT,
                            name: lang.vod_report_sub_menu
                        },
                        {
                            type: 0,
                            link: 'transmissionListReport',
                            modulesid: MODULE.TRANSMISSION_LIST_REPORT,
                            name: lang.transmission_list_report_sub_menu
                        },
                        {
                            type: 0,
                            link: 'nodeReport',
                            modulesid: MODULE.NODE_REPORT,
                            name: lang.node_report_sub_menu
                        },
                        {
                            type: 0,
                            link: 'vodCatalogueExport',
                            modulesid: MODULE.VOD_CATALOGUE_EXPORT,
                            name: lang.vod_catalogue_menu
                        },
                        {
                            type: 0,
                            link: 'promotionreport',
                            modulesid: MODULE.PROMOTION_REPORT,
                            name: lang.promotion_report_menu
                        }
                    ]
                },
                {
                    type: 1,
                    link: 'report/epg',
                    modulesid: MODULE.EPGS_SUBMENU_REPORT,
                    name: lang.epg_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'epgsExport',
                            modulesid: MODULE.EPGS_EXPORT,
                            name: lang.epgs_menu
                        }
                    ]
                },
                {
                    type: 1,
                    link: 'report/schedule',
                    modulesid: MODULE.SCHEDULE_SUBMENU_REPORT,
                    name: lang.schedule_sub_menu,
                    subMenu: [
                        {
                            type: 0,
                            link: 'scheduleExport',
                            modulesid: MODULE.SCHEDULE_EXPORT,
                            name: lang.schedule_export_menu
                        },
                        {
                            type: 0,
                            link: 'scheduleMusicQSheetExport',
                            modulesid: MODULE.SCHEDULE_MUSICQ_SHEET_EXPORT,
                            name: lang.schedule_music_qsheet__menu
                        }
                    ]
                }
            ]
        },
        {
            type: 1,
            title: lang.utility_menu,
            icon: "fa-lg fa-fw fa-solid fa-gear",
            name: lang.utility_menu,
            subMenu: utility.getUtilitySubMenuList(lang, user)
        },
    ];

}

const GetUserFavMenu = () => {
    // console.log("Getting menus from local storage");
    const userFavoriteMenus = utility.getValue(LOCALSTORAGE_KEY.userfavouritemenu);
    // console.log( lang);
    var menus = [];
    if (userFavoriteMenus !== undefined && userFavoriteMenus?.length > 0) {
        // console.log("Getting menus from local storage");
        menus = userFavoriteMenus.map((menu) => {
            return { type: 0, link: menu.URL, modulesid: menu.Menu.SID, name: menu.Name }
        });
    }

    return menus;
}


export default menuModel;

